export default () => ({
  deviceAccessGroups: {},
  deviceAccessGroupsIsLoading: false,
  error: '',
});
